
const blogOptions = ['All', 'Technical','Case Study', 'Industry','Newsletter'];

export {blogOptions};